module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/5DakhGip3w3CPkx3vUwrbH-451593c332563689cdc2d6fe0ccb34b8.jpg";